module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-3.28d6f092.png";